import { css } from "@compiled/react";

import TabGroup, {
    IndividualTabPropsCustom,
    TabColorProps
} from "@/components/wpl/tab-group/src";
import { Row } from "@/libraries/wpl/foundations/src";

const tabCustomStyles = css({
    "marginTop": "40px",
    "marginBottom": "60px",
    ".tab-group .tab-group-inner": {
        marginBlockEnd: "20px"
    },
    ".tab-group .tab-group-inner button": {
        "border": "1px solid transparent",
        "fontSize": "0.875rem",
        "@media (min-width: 1024px)": {
            fontSize: "1.25rem"
        }
    },
    ".simple-image-text-side-tabs": {
        padding: 0
    },
    '.tab-group .tab-group-inner button[aria-selected="false"]': {
        color: "var(--lp-tabs-unselected, #6b778c)"
    },
    ".tab-group .tab-group-inner button:hover": {
        borderColor: "var(--lp-tabs-hover, transparent)"
    },
    ".tab-group .tab-panel h2": {
        "color": "#253858",
        "fontSize": "1.5rem",
        "@media (min-width: 758px)": {
            fontSize: "2.25rem"
        }
    }
});
const tabSectionTitleStyles = css({
    "textAlign": "center",
    "fontSize": "1.5rem",
    "marginBlockEnd": "40px",
    "fontWeight": "500",
    "color": "#253858",
    "@media(min-width: 768px)": {
        fontSize: "2.25rem"
    }
});

export interface PaidTabsProps {
    headerText: string;
    tabStyles: TabColorProps;
    tabs: IndividualTabPropsCustom[];
}

export const PaidTabs = ({ headerText, tabStyles, tabs }: PaidTabsProps) => {
    return (
        <div css={tabCustomStyles}>
            <Row layout="12">
                <h2 css={tabSectionTitleStyles}>{headerText}</h2>
            </Row>
            <TabGroup
                tabContentType="custom"
                tabs={tabs}
                id="tabs"
                label="tabs"
                colors={tabStyles}
            />
        </div>
    );
};
